import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ChevronDown } from "lucide-react";
 * // Use <ChevronDown /> instead
 */
export const ChervonDownIcon = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.293 9.293a1 1 0 0 1 1.414 0L12 13.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414Z"
    clipRule="evenodd"
  />
);
